import {
  Message,
  Loading
} from 'element-ui';

let loading

function startLoading() { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    spinner: 'el-icon-loading', // 引入的loading图标
    background: 'rgba(255, 255, 255, 0.5)',
    target: '#app',
    // customClass: 'loadingClass'
  })
}

function endLoading() { //使用Element loading-close 方法
  loading.close()
}

//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


// Vue.prototype.openLoading = function() {
//     const loading = this.$loading({
//       lock: true,                             // 是否锁屏
//       text: '加载中',                         // 加载动画的文字
//       spinner: 'el-icon-loading',             // 引入的loading图标
//       target: '.el-table, .table-flex, .region',       // **需要遮罩的区域，这里写要添加loading的选择器**
//       fullscreen: false,
//       customClass: 'loadingclass'             // **遮罩层新增类名，如果需要修改loading的样式**
//     })
//     setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
//       loading.close();                        // 关闭遮罩层
//     },5000)
//     return loading;
//   }



// WEBPACK FOOTER //
// ./src/utils/loading.js